import Vue from 'vue'
import { decode, parsePath, withoutBase, withoutTrailingSlash, normalizeURL } from 'ufo'

import { getMatchedComponentsInstances, getChildrenComponentInstancesUsingFetch, promisify, globalHandleError, urlJoin, sanitizeComponent } from './utils'
import NuxtError from '../layouts/error.vue'
import NuxtLoading from '~/components/_core/ui/loading/loading.vue'

import '../node_modules/@mdi/font/css/materialdesignicons.min.css'

import '../assets/_core/styles/variables-theme.scss'

import '../assets/_core/styles/default.scss'

import '../assets/_core/styles/light.scss'

import '../assets/_core/styles/dark.scss'

import '../assets/styles/custom.scss'

import '../assets/styles/dark.scss'

import _4f0faee9 from '../layouts/_core/anonymous/index.vue'
import _b93be4d8 from '../layouts/_core/anonymous/script.js'
import _6681d0ab from '../layouts/_core/authenticated/index.vue'
import _7a342412 from '../layouts/_core/authenticated/script.js'
import _f3e6c806 from '../layouts/_core/default/index.vue'
import _4c02c300 from '../layouts/_core/default/script.js'
import _79b9a665 from '../layouts/_core/fullscreen/index.vue'
import _6411f4d0 from '../layouts/_core/fullscreen/script.js'
import _673e340c from '../layouts/anonymous/index.vue'
import _5f908eba from '../layouts/anonymous/script.js'
import _4961d188 from '../layouts/authenticated/index.vue'
import _c1e0a0be from '../layouts/authenticated/script.js'
import _206536d4 from '../layouts/default-full/index.vue'
import _0684f9ee from '../layouts/default-full/script.js'
import _55b2634e from '../layouts/default/index.vue'
import _7115e5cf from '../layouts/default/script.js'
import _fad9f84c from '../layouts/empty/index.vue'
import _3f6d527a from '../layouts/empty/script.js'
import _b2e15d18 from '../layouts/fullscreen/index.vue'
import _3bd6bc69 from '../layouts/fullscreen/script.js'
import _7a30cac0 from '../layouts/templates/streaming-course/carousel/index.vue'
import _aaf0ce86 from '../layouts/templates/streaming-course/carousel/script.js'
import _6b2b4cf5 from '../layouts/templates/streaming-course/index.vue'
import _0aba3108 from '../layouts/templates/streaming-course/script.js'
import _45456630 from '../layouts/templates/streaming-render/index.vue'
import _73e33f2d from '../layouts/templates/streaming-render/script.js'
import _3d7b1a95 from '../layouts/templates/streaming-render/sidebar-menu/index.vue'
import _0ac57cb2 from '../layouts/templates/streaming-render/sidebar-menu/menu-items/index.vue'
import _5e65f8eb from '../layouts/templates/streaming-render/sidebar-menu/menu-items/script.js'
import _fb37d130 from '../layouts/templates/streaming-render/sidebar-menu/script.js'
import _67c26ade from '../layouts/templates/timeline-course/index.vue'
import _bdf25f82 from '../layouts/templates/timeline-course/script.js'
import _41dc8419 from '../layouts/templates/timeline-render/index.vue'
import _0a2fde64 from '../layouts/templates/timeline-render/script.js'
import _6f6c098b from './layouts/default.vue'

const layouts = { "__core/anonymous/index": sanitizeComponent(_4f0faee9),"__core/anonymous/script": sanitizeComponent(_b93be4d8),"__core/authenticated/index": sanitizeComponent(_6681d0ab),"__core/authenticated/script": sanitizeComponent(_7a342412),"__core/default/index": sanitizeComponent(_f3e6c806),"__core/default/script": sanitizeComponent(_4c02c300),"__core/fullscreen/index": sanitizeComponent(_79b9a665),"__core/fullscreen/script": sanitizeComponent(_6411f4d0),"_anonymous/index": sanitizeComponent(_673e340c),"_anonymous/script": sanitizeComponent(_5f908eba),"_authenticated/index": sanitizeComponent(_4961d188),"_authenticated/script": sanitizeComponent(_c1e0a0be),"_default-full/index": sanitizeComponent(_206536d4),"_default-full/script": sanitizeComponent(_0684f9ee),"_default/index": sanitizeComponent(_55b2634e),"_default/script": sanitizeComponent(_7115e5cf),"_empty/index": sanitizeComponent(_fad9f84c),"_empty/script": sanitizeComponent(_3f6d527a),"_fullscreen/index": sanitizeComponent(_b2e15d18),"_fullscreen/script": sanitizeComponent(_3bd6bc69),"_templates/streaming-course/carousel/index": sanitizeComponent(_7a30cac0),"_templates/streaming-course/carousel/script": sanitizeComponent(_aaf0ce86),"_templates/streaming-course/index": sanitizeComponent(_6b2b4cf5),"_templates/streaming-course/script": sanitizeComponent(_0aba3108),"_templates/streaming-render/index": sanitizeComponent(_45456630),"_templates/streaming-render/script": sanitizeComponent(_73e33f2d),"_templates/streaming-render/sidebar-menu/index": sanitizeComponent(_3d7b1a95),"_templates/streaming-render/sidebar-menu/menu-items/index": sanitizeComponent(_0ac57cb2),"_templates/streaming-render/sidebar-menu/menu-items/script": sanitizeComponent(_5e65f8eb),"_templates/streaming-render/sidebar-menu/script": sanitizeComponent(_fb37d130),"_templates/timeline-course/index": sanitizeComponent(_67c26ade),"_templates/timeline-course/script": sanitizeComponent(_bdf25f82),"_templates/timeline-render/index": sanitizeComponent(_41dc8419),"_templates/timeline-render/script": sanitizeComponent(_0a2fde64),"_default": sanitizeComponent(_6f6c098b) }

export default {
  render (h, props) {
    const loadingEl = h('NuxtLoading', { ref: 'loading' })

    const layoutEl = h(this.layout || 'nuxt')
    const templateEl = h('div', {
      domProps: {
        id: '__layout'
      },
      key: this.layoutName
    }, [layoutEl])

    const transitionEl = h('transition', {
      props: {
        name: 'layout',
        mode: 'out-in'
      },
      on: {
        beforeEnter (el) {
          // Ensure to trigger scroll event after calling scrollBehavior
          window.$nuxt.$nextTick(() => {
            window.$nuxt.$emit('triggerScroll')
          })
        }
      }
    }, [templateEl])

    return h('div', {
      domProps: {
        id: '__nuxt'
      }
    }, [
      loadingEl,

      transitionEl
    ])
  },

  data: () => ({
    isOnline: true,

    layout: null,
    layoutName: '',

    nbFetching: 0
    }),

  beforeCreate () {
    Vue.util.defineReactive(this, 'nuxt', this.$options.nuxt)
  },
  created () {
    // Add this.$nuxt in child instances
    this.$root.$options.$nuxt = this

    if (process.client) {
      // add to window so we can listen when ready
      window.$nuxt = this

      this.refreshOnlineStatus()
      // Setup the listeners
      window.addEventListener('online', this.refreshOnlineStatus)
      window.addEventListener('offline', this.refreshOnlineStatus)
    }
    // Add $nuxt.error()
    this.error = this.nuxt.error
    // Add $nuxt.context
    this.context = this.$options.context
  },

  async mounted () {
    this.$loading = this.$refs.loading
  },

  watch: {
    'nuxt.err': 'errorChanged'
  },

  computed: {
    isOffline () {
      return !this.isOnline
    },

    isFetching () {
      return this.nbFetching > 0
    },

    isPreview () {
      return Boolean(this.$options.previewData)
    },
  },

  methods: {
    refreshOnlineStatus () {
      if (process.client) {
        if (typeof window.navigator.onLine === 'undefined') {
          // If the browser doesn't support connection status reports
          // assume that we are online because most apps' only react
          // when they now that the connection has been interrupted
          this.isOnline = true
        } else {
          this.isOnline = window.navigator.onLine
        }
      }
    },

    async refresh () {
      const pages = getMatchedComponentsInstances(this.$route)

      if (!pages.length) {
        return
      }
      this.$loading.start()

      const promises = pages.map(async (page) => {
        let p = []

        // Old fetch
        if (page.$options.fetch && page.$options.fetch.length) {
          p.push(promisify(page.$options.fetch, this.context))
        }

        if (page.$options.asyncData) {
          p.push(
            promisify(page.$options.asyncData, this.context)
              .then((newData) => {
                for (const key in newData) {
                  Vue.set(page.$data, key, newData[key])
                }
              })
          )
        }

        // Wait for asyncData & old fetch to finish
        await Promise.all(p)
        // Cleanup refs
        p = []

        if (page.$fetch) {
          p.push(page.$fetch())
        }
        // Get all component instance to call $fetch
        for (const component of getChildrenComponentInstancesUsingFetch(page.$vnode.componentInstance)) {
          p.push(component.$fetch())
        }

        return Promise.all(p)
      })
      try {
        await Promise.all(promises)
      } catch (error) {
        this.$loading.fail(error)
        globalHandleError(error)
        this.error(error)
      }
      this.$loading.finish()
    },
    errorChanged () {
      if (this.nuxt.err) {
        if (this.$loading) {
          if (this.$loading.fail) {
            this.$loading.fail(this.nuxt.err)
          }
          if (this.$loading.finish) {
            this.$loading.finish()
          }
        }

        let errorLayout = (NuxtError.options || NuxtError).layout;

        if (typeof errorLayout === 'function') {
          errorLayout = errorLayout(this.context)
        }

        this.nuxt.errPageReady = true
        this.setLayout(errorLayout)
      }
    },

    setLayout (layout) {
      if (!layout || !layouts['_' + layout]) {
        layout = 'default'
      }
      this.layoutName = layout
      this.layout = layouts['_' + layout]
      return this.layout
    },
    loadLayout (layout) {
      if (!layout || !layouts['_' + layout]) {
        layout = 'default'
      }
      return Promise.resolve(layouts['_' + layout])
    },
  },

  components: {
    NuxtLoading
  }
}
